import type { ComponentType } from 'react'
import type { ContactChannel } from '../components/page'
import { ContactDetails } from '../components/steps/contact-details'
import { IssueDescription } from '../components/steps/issue-description'
import { Confirmation } from '../components/steps/confirmation'

export const STEP_REGISTRY: Record<ContactChannel, ComponentType[]> = {
  callback: [ContactDetails, IssueDescription, Confirmation],
  email: [ContactDetails, IssueDescription, Confirmation],
}
